const SgiToolbarEO = function () {
    return {
        btnAlg: "center",//按钮位置
        ctlH: 0,
        ctlN: "工具条",
        ctlW: '100%',
        desId: "EP_EO_UI_3010",
        isDis: false,//禁用
        tlbAlg: "top",//工具条位置
        btnAlg: 'right'
    }
}
export { SgiToolbarEO };
export default SgiToolbarEO;



// WEBPACK FOOTER //
// ./~/rt-sd-common/sgiCompEO/SgiToolbarEO.js